var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M6.39 37.33a37.94 37.94 0 0162.16 0l.12.17-.13.17a37.94 37.94 0 01-62.15 0s0 0 0 0a.3.3 0 010-.34z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.47,
    cy: 37.5,
    r: 11.21,
    className: "fill stroke",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M31.65 35.36a6.08 6.08 0 017.42-4.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.24527a2df2ab49d0ab391b2b6cc58508.svg";
export { ForwardRef as ReactComponent };